import React from 'react';
import styled from 'styled-components';
import { fontSize } from '../../styles';

const StyledRecaptchaText = styled.p`
  ${fontSize(11)};

  a {
    text-decoration: underline;
  }
`;

export const RecaptchaText = ({ ...props }) => (
  <StyledRecaptchaText {...props}>
    This site is protected by reCAPTCHA and the Google{' '}
    <a href="https://policies.google.com/privacy" target="_blank">
      Privacy Policy
    </a>{' '}
    and{' '}
    <a href="https://policies.google.com/terms" target="_blank">
      Terms of Service
    </a>{' '}
    apply.
  </StyledRecaptchaText>
);
